<script lang="ts">
import { errorHandler } from 'services/error-handling.service'
import { useAuthStore } from 'stores/auth'
import { useProfileStore } from 'stores/profile'
import { setLocaleYup } from 'utils/validation'
import { computed, defineComponent, watch } from 'vue'

export default defineComponent({
  setup() {
    const authStore = useAuthStore()
    const profileStore = useProfileStore()

    const isAuth = computed(() => !!authStore.token)

    watch(
      isAuth,
      (value, oldValue) => {
        if (value) {
          profileStore
            .fetchProfile()
            // .then((profile) => {
            //   const identifyEvent = new Identify()
            //   identifyEvent.set('subdivision', profile.subdivision.name)
            //   profile.subdivision.cityName
            //   && identifyEvent.set('city', profile.subdivision.cityName)
            //
            //   setUserId(profile.id)
            //   identify(identifyEvent)
            // })
            .catch(errorHandler)
        } else if (oldValue && !value) {
          profileStore.$reset()
        }
      },
      { immediate: true },
    )

    setLocaleYup()
  },
})
</script>

<template>
  <RouterView />

  <UToaster :ui="{ viewport: 'tw:bottom-20' }" />
</template>
